// /src/store/paymentManagment/types.ts

import { Payment, GetPaymentListParams } from '../../dataTypes/paymentManagment/types';

// Constantes d'action
export const FETCH_PAYMENTS_REQUEST = 'FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAILURE = 'FETCH_PAYMENTS_FAILURE';

export const FETCH_PAYMENT_BY_ID_REQUEST = 'FETCH_PAYMENT_BY_ID_REQUEST';
export const FETCH_PAYMENT_BY_ID_SUCCESS = 'FETCH_PAYMENT_BY_ID_SUCCESS';
export const FETCH_PAYMENT_BY_ID_FAILURE = 'FETCH_PAYMENT_BY_ID_FAILURE';

// Interfaces pour l'état
export interface PaymentState {
  loading: boolean;
  payments: Map<number, Payment>;
  error: string | null;
  lastFetchTimestamp: number;
  lastFetchParams: GetPaymentListParams | null;
}

export const initialPaymentState: PaymentState = {
  loading: false,
  payments: new Map(),
  error: null,
  lastFetchTimestamp: 0,
  lastFetchParams: null,
};

// Interfaces pour les actions
export interface FetchPaymentsRequestAction {
  type: typeof FETCH_PAYMENTS_REQUEST;
  payload: GetPaymentListParams;
}

export interface FetchPaymentsSuccessAction {
  type: typeof FETCH_PAYMENTS_SUCCESS;
  payload: {
    payments: Payment[];
    lastFetchTimestamp: number;
    lastFetchParams: GetPaymentListParams | null;
  };
}

export interface FetchPaymentsFailureAction {
  type: typeof FETCH_PAYMENTS_FAILURE;
  payload: string;
}

export interface FetchPaymentByIdRequestAction {
  type: typeof FETCH_PAYMENT_BY_ID_REQUEST;
  payload: number;
}

export interface FetchPaymentByIdSuccessAction {
  type: typeof FETCH_PAYMENT_BY_ID_SUCCESS;
  payload: Payment;
}

export interface FetchPaymentByIdFailureAction {
  type: typeof FETCH_PAYMENT_BY_ID_FAILURE;
  payload: string;
}

export type PaymentActionTypes =
  | FetchPaymentsRequestAction
  | FetchPaymentsSuccessAction
  | FetchPaymentsFailureAction
  | FetchPaymentByIdRequestAction
  | FetchPaymentByIdSuccessAction
  | FetchPaymentByIdFailureAction;
